document.addEventListener("page:loaded", function () {
  console.log("🚴");
  const notifyMeButton = document.getElementById("notify-me");
  if (notifyMeButton) {
    notifyMeButton.addEventListener("click", function () {
      const notifyModal = document.getElementById("notify-modal");

      notifyModal?.classList.add("show");
      notifyModal?.addEventListener("click", function (event) {
        if (event.target === notifyModal) {
          notifyModal.classList.remove("show");
        }
      });
      const modalCloseButton = document.getElementById("modal-close-button");
      modalCloseButton?.addEventListener("click", function () {
        notifyModal.classList.remove("show");
      });
      const notifyMeForm = document.getElementById("notify-me-form");
      if (notifyMeForm) {
        notifyMeForm.addEventListener("submit", function (event) {
          event.preventDefault();
          notifyMeButton.disabled=true;
        const notifiedText =   notifyMeButton.dataset.notified;
            notifyMeButton.innerText = notifiedText;
          
          const email = document.getElementById("notifyMeEmail").value;
          console.log(email);
          // get selected option from select data-product-select
          const productSelect = document.querySelector("[data-product-select]");
          const variant =
            productSelect.options[productSelect.selectedIndex].value;


          // save variant id to localstorage
       //   const dataFromLocalStorage = JSON.parse(localStorage.getItem('klaviyoNotifyCois')) || {};
         // dataFromLocalStorage[variant] = true;
        //  localStorage.setItem('klaviyoNotifyCois', JSON.stringify(dataFromLocalStorage));

          
          fetch(
            "https://europe-west1-thomasmaclean.cloudfunctions.net/cois-klaviyo",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ email, variant, subscribe: document.getElementById("subscribeToNewsletterCois").checked }),
            }
          );

          notifyModal.classList.remove("show");
         
        });
      }
    });
  }
});
